import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SparklineComponent } from './atoms/sparkline/sparkline.component'

import { DragDropModule } from '@angular/cdk/drag-drop'
import { FormsModule } from '@angular/forms'
import { FeatherModule } from 'angular-feather'
import { NgApexchartsModule } from 'ng-apexcharts'
import { SearchService } from '../services/search.service'
import { BarMetricComponent } from './atoms/bar-metric/bar-metric.component'
import { CardComponent } from './atoms/card/card.component'
import { DropdownComponent } from './atoms/dropdown/dropdown.component'
import { ComponentFileUploader } from './atoms/file-uploader/file-uploader.component'
import { GridComponent } from './atoms/grid/grid.component'
import { ImageDropComponent } from './atoms/image-drop/image-drop.component'
import { ImageGalleryComponent } from './atoms/image-gallery/image-gallery.component'
import { PaneComponent } from './atoms/pane/pane.component'
import { ProductMetaComponent } from './atoms/product-meta/product-meta.component'
import { SaveButtonComponent } from './atoms/save-button/save-button.component'
import { SingleTagPickerComponent } from './atoms/single-tag-picker/single-tag-picker.component'
import { TagEditorComponent } from './atoms/tag-editor/tag-editor.component'
import { TagSelectorComponent } from './atoms/tag-selector/tag-selector.component'
import { ViewportToggleComponent } from './atoms/viewport-toggle/viewport-toggle.component'
import { ElementSizeDirective } from './directives/element-size.directive'
import { CollectionItemComponent } from './molecules/collection-item/collection-item.component'
import { SantisePipe } from './pipes/utility.pipe'

let Declarations = [
	SaveButtonComponent,
	SparklineComponent,
	CardComponent,
	CollectionItemComponent,
	ImageGalleryComponent,
	ProductMetaComponent,
	BarMetricComponent,
	ComponentFileUploader,
	TagSelectorComponent,
	SantisePipe,
	ImageDropComponent,
	ElementSizeDirective,
	DropdownComponent,
	TagEditorComponent,
	PaneComponent,
	ViewportToggleComponent,
	SingleTagPickerComponent,
	GridComponent,
]

@NgModule({
    providers: [SearchService],
    imports: [FeatherModule, CommonModule, NgApexchartsModule, FormsModule, DragDropModule, Declarations],
    exports: [Declarations],
})
export class CommonComponentsModule {}
